import { Download } from "lucide-react";

import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { useIsLoadDownloader } from "@/auth/roles";

export const DownloadLoads = ({ filePath, className }) => {
    const canDownload = useIsLoadDownloader();
    if (!canDownload) {
        return null;
    }
    return (
        <div className={cn("flex text-cm-p-text-secondary text-xs font-medium items-center justify-center rounded", className)}>
            {filePath ? (
                <a
                    href={`${import.meta.env.VITE_API_ROUTE}files/loads-csv/${filePath}`}
                    download
                    className="w-full h-full inline-flex items-center gap-2"
                >
                    <Download className="w-4 h-4" />
                    <TranslatedText text="Download loads" />
                </a>
            ) : (
                <span className="w-full h-full inline-flex items-center gap-2 opacity-50 cursor-not-allowed">
                    <Download className="w-4 h-4" />
                    <TranslatedText text="No download file" />
                </span>
            )}
        </div>
    );
};
